import {System} from '@fantasmagames/core/src/System';
import {Device} from '@fantasmagames/core/src/device/Device';
import {RectangleArea} from '@fantasmagames/core/src/geom/RectangleArea';
import {DeviceType} from '@fantasmagames/core/src/device/DeviceType';
import DI from '@fantasmagames/slot/src/common/inversify/constants/DI';
import {DESKTOP_VIEWPORT, MOBILE_VIEWPORT} from '@fantasmagames/slot/src/config/config';

export class BaseGame {
	protected _name: string;
	protected _onStartGame: Function;
	protected _system: System;

	constructor(name: string, onStartGame: Function, getBaseUrlPath: Function = null, majorPerformanceCaveat: number = 1) {
		this._name = name;
		this._onStartGame = onStartGame;

		this._system = this.createSystem(getBaseUrlPath, majorPerformanceCaveat);

		this.init();
	}

	protected createSystem(getBaseUrlPath: Function, majorPerformanceCaveat: number): System {
		return new System(this.initViewport.bind(this), this.onReady.bind(this), getBaseUrlPath, majorPerformanceCaveat);
	}

	protected init(): void {
		//
	}

	protected initViewport(device: Device, viewportRect: RectangleArea): void {
		if (device.type === DeviceType.DESKTOP) {
			viewportRect.width = DESKTOP_VIEWPORT.width;
			viewportRect.height = DESKTOP_VIEWPORT.height;
		}
		if (device.type === DeviceType.MOBILE) {
			viewportRect.width = MOBILE_VIEWPORT.width;
			viewportRect.height = MOBILE_VIEWPORT.height;
		}
	}

	protected disableContextMenu(canvas: any): void {
		// const canvas = document.getElementsByTagName('canvas')[0];
		canvas.addEventListener('contextmenu', (event) => event.preventDefault());
	}

	protected onReady(): void {
		const gameContainer: PIXI.Container = new PIXI.Container();
		this._system.app.stage.addChild(gameContainer);
		this._system.container.bind<PIXI.Container>(DI.PixiStageContainer).toConstantValue(gameContainer);

		this._onStartGame();
		try {
			const canvas = document.getElementById('GameCanvas');
			this.disableContextMenu(canvas);
		} catch (error) {
			// console.error(`Could not disable contextmenu.`);
		}

		// new DebugStats();
	}

	public get name(): string {
		return this._name;
	}

	public get system(): System {
		return this._system;
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/system/BaseGame.ts